import { createVideoCardsBiLogger } from '@wix/wix-vod-shared/common';
import { logBi } from '../../../../worker/actions/bi';

export default createVideoCardsBiLogger(logBi);
